'use client';

import { useTranslations } from 'next-intl';

type FooterTexProps = {
  isAutoRenewOn: boolean;
};

const FooterText = ({ isAutoRenewOn }: FooterTexProps) => {
  const tCheckout = useTranslations('checkout');

  return (
    <div className="sm:col-span-6 text-gray-600 text-sm flex justify-center items-center mt-[-4px]">
      <p>
        {isAutoRenewOn ? (
          <span className="text-sm">{tCheckout('renewText')}</span>
        ) : (
          <span className="text-sm">{tCheckout('expireText')}</span>
        )}
      </p>
    </div>
  );
};

export default FooterText;
